export function decodeEmail(email: string) {
  return atob(email);
}
